import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorState, PermissionState } from './Visual';

interface UserNavigationErrorProps {
  code: number;
  description: string;
  actions?: ReactElement;
}

const UserNavigationError = ({ code, description, actions }: UserNavigationErrorProps) => {
  const { t } = useTranslation();
  const title = `${code}. ${t('components.UserNavigationError.shortDescription')}`;

  if (code === 403) {
    return <PermissionState title={title} description={description} actions={actions} />;
  }

  return <ErrorState title={title} description={description} actions={actions} />;
};

export default UserNavigationError;
